/**
 * Feedback Types for Thai Security Directory
 * Matches backend schema
 */

// Feedback Category Enum
export enum FeedbackCategory {
  BUG_REPORT = 'BUG_REPORT',
  FEATURE_REQUEST = 'FEATURE_REQUEST',
  GENERAL_FEEDBACK = 'GENERAL_FEEDBACK',
  COMPLAINT = 'COMPLAINT',
  COMPLIMENT = 'COMPLIMENT',
  OTHER = 'OTHER',
}

// Feedback Status Enum
export enum FeedbackStatus {
  NEW = 'NEW',
  READ = 'READ',
  IN_PROGRESS = 'IN_PROGRESS',
  RESOLVED = 'RESOLVED',
  CLOSED = 'CLOSED',
}

// Feedback Data Interface (for API response)
export interface Feedback {
  id: string;
  userId?: string | null;
  subject: string;
  category: FeedbackCategory;
  message: string;
  rating?: number | null;
  email?: string | null;
  status: FeedbackStatus;
  createdAt: string;
  updatedAt: string;
  resolvedAt?: string | null;
  resolvedBy?: string | null;
  adminNotes?: string | null;
}

// Create Feedback Request Interface
export interface CreateFeedbackRequest {
  subject: string;
  category: FeedbackCategory;
  message: string;
  rating?: number;
  email?: string;
}

// Feedback List Response
export interface FeedbackListResponse {
  feedbacks: Feedback[];
  total: number;
  page: number;
  per_page: number;
  has_next: boolean;
  has_prev: boolean;
}

// Feedback Status Display
export interface FeedbackStatusDisplay {
  text: string;
  color: 'yellow' | 'blue' | 'orange' | 'green' | 'gray';
  bgColor: string;
  textColor: string;
}

// Category Display with Emoji
export interface FeedbackCategoryDisplay {
  label: string;
  emoji: string;
  value: FeedbackCategory;
}
